'use strict';

const Action = require('./Action');

/**
 * @typedef {object} ExportedMessageAction
 *
 * @property {string} func Nombre de la función: showFieldMessage
 * @property {Array}  args Argumentos de entrada a la función:
 *                         - el ID del campo
 *                         - el ID del mensaje
 */

/**
 * Clase de gestión de una regla de tipo Mostrar un mensaje asociado a un campo
 *
 * @extends {Structure.Action}
 *
 * @memberOf Structure
 */
class MessageAction extends Action {
    /**
     * @inheritDoc
     */
    constructor(rawAction) {
        super(rawAction);

        this.type = Action.Types.MESSAGE;
        this.function = 'showFieldMessage';

        this.message = rawAction.message || '';
    }

    /**
     * Obtiene el texto del mensaje de error
     *
     * @return {string} El mensaje de error definido
     */
    getMessage() {
        return this.message;
    }

    /**
     * Exportación de la acción en un objeto para la ejecución de las reglas
     *
     * @return {ExportedAction} Objeto de exportación de la acción
     */
    export() {
        const rawAction = super.export();
        rawAction.message = this.message;

        return rawAction;
    }
}

module.exports = MessageAction;
